<template>
  <div v-loading.body="loading">
    <div class="c_page-title">
      <div>档口助手人员管理</div>
      <el-button
        class="icon-fresh"
        size="mini"
        icon="el-icon-refresh"
        @click="fetchData(true)"
        >刷新</el-button
      >
    </div>
    <el-row class="filter">
      <el-col>
        <div
          style="
            background: #f3f3f3;
            height: 30px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>查询搜索</div>
          <el-button
            type="text"
            style="margin-left: auto"
            :icon="filterFold ? 'el-icon-arrow-down' : 'el-icon-arrow-up'"
            @click="toggleFilter"
          >
            {{ filterFold ? "展开筛选" : "收起筛选" }}
          </el-button>
        </div>
        <el-collapse-transition>
          <div v-show="!filterFold">
            <div style="padding: 10px 25px">
              <el-form :inline="true" :model="form" class="demo-form-inline">
                <el-form-item label="">
                  <el-input
                    v-model="form.phone"
                    placeholder="手机号码"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.supply_name"
                    placeholder="商家"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.admin_name"
                    placeholder="管理员姓名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-input
                    v-model="form.parent_admin_name"
                    placeholder="授权人姓名"
                    @keyup.native.enter="search"
                  ></el-input>
                </el-form-item>
                <el-form-item label="">
                  <el-select v-model="form.role" filterable placeholder="角色">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option
                      v-for="item in roleOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>
                <el-form-item label="">
                  <el-select v-model="form.status" placeholder="状态">
                    <el-option label="全部" value="">全部</el-option>
                    <el-option
                      v-for="item in statusOption"
                      :key="item.value"
                      :label="item.label"
                      :value="item.value"
                    >
                    </el-option>
                  </el-select>
                </el-form-item>

                <el-form-item label="注册时间：">
                  <el-date-picker
                    v-model="form.create_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="授权时间：">
                  <el-date-picker
                    v-model="form.auth_time"
                    type="daterange"
                    value-format="yyyy-MM-dd"
                    range-separator="至"
                    start-placeholder="开始日期"
                    end-placeholder="结束日期"
                  >
                  </el-date-picker>
                </el-form-item>

                <el-form-item>
                  <el-button type="primary" @click="search">查询</el-button>
                </el-form-item>
              </el-form>
            </div>
          </div>
        </el-collapse-transition>
      </el-col>
    </el-row>
    <el-row>
      <el-col style="border: 1px solid #ddd">
        <div
          style="
            background: #f3f3f3;
            height: 50px;
            line-height: 30px;
            padding: 0 25px;
            display: flex;
            align-items: center;
          "
        >
          <div>数据列表：</div>
          <el-button
            style="margin-left: auto"
            type="success"
            size="mini"
            @click="output"
            >导出</el-button
          >
        </div>
        <div style="margin-bottom: 0">
          <el-table
            v-if="resData"
            ref="multipleTable"
            v-loading="tableLoading"
            height="800"
            :data="resData.list.data"
            tooltip-effect="dark"
            style="width: 100%"
            @selection-change="handleSelectionChange"
          >
            <el-table-column
              align="center"
              prop="phone"
              label="手机号码"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="role"
              label="角色"
            ></el-table-column>

            <el-table-column
              align="center"
              prop="admin_name"
              label="管理员姓名"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="supply_list"
              label="绑定商家"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="status"
              label="状态"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="create_time"
              label="注册时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="auth_time"
              label="授权时间"
            ></el-table-column>
            <el-table-column
              align="center"
              prop="parent_admin_name"
              label="授权人"
            ></el-table-column>
            <el-table-column fixed="right" label="操作" width="100">
              <template slot-scope="scope">
                <el-button type="text" @click="openSave(scope.row)">
                  编辑</el-button
                >
              </template>
            </el-table-column>
          </el-table>

          <el-dialog
            title="编辑档口人员"
            :visible.sync="dialogFormVisible"
            width="30%"
            center
          >
            <el-form :model="form2">
              <el-form-item label="角色">
                <el-select v-model="form2.role" placeholder="请选择角色">
                  <el-option
                    v-for="item in resData2.roleOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
              <el-form-item label="状态">
                <el-select v-model="form2.status" placeholder="请选择采状态">
                  <el-option
                    v-for="item in statusOption"
                    :key="item.value"
                    :label="item.label"
                    :value="item.value"
                  >
                  </el-option>
                </el-select>
              </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
              <el-button @click="dialogFormVisible = false">取 消</el-button>
              <el-button type="primary" @click="saveProfile">确 定</el-button>
            </div>
          </el-dialog>
        </div>

        <div v-if="resData" style="text-align: right; padding: 25px">
          <el-pagination
            :current-page.sync="resData.list.current_page"
            background
            layout="total, prev, pager, next, jumper, sizes "
            :total="resData.list.total"
            :page-size="10"
            :page-sizes="[10, 50, 100, 200]"
            @size-change="handleSizeChange"
            @current-change="handleCurrentChange"
          >
          </el-pagination>
        </div>
      </el-col>
    </el-row>
  </div>
</template>

<script>
import apiBaseURL from "@/utils/baseUrl.js";

export default {
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.fetchData();
    });
  },
  data() {
    return {
      supply_ids: [],
      logData: [],
      logVisible: false,
      resData: {
        pg_list: [],
        reson_2: [],
        child_market: [],
      },
      resData2: {
        pgOption: [],
        roleOption: [],
      },
      supply: {
        list: [],
      },
      form: {
        status: "",
        create_time: [],
        supply_id: "",
      },
      form2: {
        status: "",
        create_time: [],
        supply_id: "",
      },
      statusOption: [
        {
          value: "0",
          label: "正常",
        },
        {
          value: "1",
          label: "禁用",
        },
      ],
      roleOption: [],
      loading: false,
      tableLoading: false,
      url: "/erp/SupplyProfile/getlist",
      curPage: 1,
      filterFold: false,
      isAll: false,
      supplyData: null,
      dialogFormVisible: false,
      dialogPgidsIsShow: false, // 弹出框选择代采组是否显示
    };
  },
  computed: {
    filteredForm() {
      for (const key in this.form) {
        if (
          this.form[key] === undefined ||
          this.form[key] === "" ||
          this.form[key] === null
        ) {
          delete this.form[key];
        }
      }
      return this.form;
    },
    filteredForm2() {
      for (const key in this.form2) {
        if (
          this.form2[key] === undefined ||
          this.form2[key] === "" ||
          this.form2[key] === null
        ) {
          delete this.form2[key];
        }
      }
      return this.form2;
    },
  },
  mounted() {
    const { pg_id } = this.$route.query;
    const { pgid } = this.$route.query;
    const { pg_member_id } = this.$route.query;
    // if (pg_id != "undefined" && pg_id != null && pg_id != "" && pg_id) {
    //   this.form.pg_id = pg_id;
    // }
    // if (pgid != "undefined" && pgid != null && pgid != "" && pgid) {
    //   this.form.pgid = pgid;
    // }
    if (
      pg_member_id != "undefined" &&
      pg_member_id != null &&
      pg_member_id != "" &&
      pg_member_id
    ) {
      this.form.pg_member_id = pg_member_id;
    }
  },
  methods: {
    handleSizeChange(e) {
      this.form.page_size = e;
      this.fetchData();
    },
    output() {
      this.form.is_excel = 1;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.form.is_excel = 0;
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            window.open(apiBaseURL + res.data.data.file);
          }
        }
      });
    },
    fetchData(showLoading) {
      if (showLoading) {
        this.loading = true;
      }
      this.$http.post(this.url, this.filteredForm).then((res) => {
        this.loading = false;
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          console.log(res.data);
          this.resData = res.data.data;
          this.roleOption = res.data.data.roleOption;
        }
      });
    },
    toggleFilter() {
      this.filterFold = !this.filterFold;
    },
    handleSelectionChange(val) {
      const temp = val;
      temp.forEach((element) => {
        this.supply_ids.push(element.supply_id);
      });
      const multipleSelection = [];
      for (const key in val) {
        multipleSelection[key] = {
          id: val[key].id,
        };
      }
      this.form.multipleSelection = JSON.stringify(multipleSelection);
    },
    // 切换页码
    handleCurrentChange(val) {
      this.form.page = val;
      this.tableLoading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.tableLoading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    search() {
      this.form.page = 1;
      this.loading = true;
      this.$http.post(this.url, this.filteredForm).then((res) => {
        setTimeout(() => {
          this.loading = false;
        }, 200);
        if (res.data.code !== 200) {
          this.$message.error(res.data.msg);
        } else {
          this.resData = res.data.data;
        }
      });
    },
    trim(str, is_global) {
      let result;
      result = str.replace(/(^\s+)|(\s+$)/g, "");
      if (is_global.toLowerCase() == "g") {
        result = result.replace(/\s/g, "");
      }
      return result;
    },
    openSave(row) {
      this.dialogFormVisible = true;
      this.$http
        .post("/erp/SupplyProfile/getProfile", { s_id: row.s_id })
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.resData2 = res.data.data;
            this.form2 = res.data.data.data;
            console.log(this.form2);
            if (res.data.data.data.is_admin == 1) {
              this.dialogPgidsIsShow = true;
            } else {
              this.dialogPgidsIsShow = false;
            }
          }
        });
    },
    saveProfile() {
      this.dialogFormVisible = false;
      this.loading = true;
      this.$http
        .post("/erp/SupplyProfile/saveProfile", this.filteredForm2)
        .then((res) => {
          setTimeout(() => {
            this.loading = false;
          }, 200);
          if (res.data.code !== 200) {
            this.$message.error(res.data.msg);
          } else {
            this.$message.success({
              message: res.data.msg,
            });
            this.fetchData(true);
          }
        });
    },
  },
};
</script>

<style scoped>
.row {
  height: 60px;
}

.column {
  text-align: center;
  border: 1px solid #ddd;
  font-size: 12px;
}

.data-statics {
  background: #f3f3f3;
  height: 40px;
  font-size: 14px;
  color: #333;
  line-height: 40px;
  padding: 0 25px;
}

.filter {
  border: 1px solid #ddd;
}

.el-row {
  margin-bottom: 20px;
}

.el-row:last-child {
  margin-bottom: 0;
}
</style>



// WEBPACK FOOTER //
// src/pages/supply/ProfileManager.vue